// src/components/SectionCard.jsx
import React from 'react';

export default function SectionCard({ title, subtitle = '', headerAction = null, className = '', compact = false, children }) {
  return (
    <section className={`card ${compact ? 'p-3' : 'p-5'} ${className}`}>
      {title ? (
        <div className={`${compact ? 'mb-1' : 'mb-3'} flex items-start justify-between gap-4`}>
          <div>
            <div className={`${compact ? 'text-sm' : 'text-lg'} font-semibold text-brand`}>
              {title}
            </div>
            {subtitle ? (
              <div className="mt-0.5 text-xs font-normal text-muted">
                {subtitle}
              </div>
            ) : null}
          </div>
          {headerAction ? <div className="shrink-0">{headerAction}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
